import { useEffect, useState } from 'react';
import { API_ENDPOINTS, buildApiUrl } from '../config/api';
import { notifySupportApiNetworkError, notifySupportApiServerError } from '../utils/supportApiErrorNotifier';

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch(buildApiUrl(API_ENDPOINTS.VEHICLE_CATEGORIES));
        
        if (!response.ok) {
          notifySupportApiServerError(response.status);
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        setCategories(data);
      } catch (err) {
        notifySupportApiNetworkError(err);
        console.error('Error fetching categories:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []); // Solo se ejecuta una vez al montar el componente

  return { categories, loading, error };
}; 